import { render, staticRenderFns } from "./AdicionaNoCarrinho.vue?vue&type=template&id=a892e068&scoped=true"
import script from "./AdicionaNoCarrinho.vue?vue&type=script&lang=js"
export * from "./AdicionaNoCarrinho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a892e068",
  null
  
)

export default component.exports